// Responsive Unsplash helpers (auto-format → WebP/AVIF, sized variants).
const base = (url) => url.split("?")[0];
export const unsplash = (url, w, q = 70) => `${base(url)}?auto=format&fit=crop&q=${q}&w=${w}`;
export const unsplashSrcSet = (url, widths = [480, 768, 1080, 1400], q = 70) =>
  widths.map((w) => `${unsplash(url, w, q)} ${w}w`).join(", ");

// Team headshots ship as 160/320/640px square WebPs (e.g. /team-ria-160.webp).
export const teamSrcSet = (photo) => {
  const base = photo.replace(/\.webp$/, "");
  return `${base}-160.webp 160w, ${base}-320.webp 320w, ${photo} 640w`;
};
